module.exports = __webpack_public_path__ + "static/media/11NEPAD3.5bf7c853.jpg";